/*
  Brand page — sections/shoes-egy-brand-collection.liquid.

  - Pairs per model, from sections/shoes-egy-brand-models.liquid against the
    brand: fills the model chips (most pairs first, All stays first) and the
    "+N colours" on each card (the model's other pairs).
  - Sizes sold out across the brand, from sections/shoes-egy-brand-sizes.liquid
    with the availability filter on: those size chips fade and strike through.
  - Quick add lives in assets/shoes-egy-quick-add.js (shared with the
    Saved page).
  - Sort submits on change.
  - The Filter panel (price, brand on mixed pages, shoe type) opens as a
    dialog and submits as a plain GET form, so it also works as links.
  - Load more appends the next page's cards in place; the link is the real
    ?page= URL, so it still works without JS.
  - Ad landing pages (ad-…): the size bar sticks under the header, and a
    shopper coming back from a product lands where they left.
*/
(function () {
  function parse(html, sel) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
    if (!el) throw new Error('no ' + sel);
    return el;
  }
  function get(url) {
    return fetch(url).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); });
  }
  function withSection(url, id) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(id);
  }

  document.querySelectorAll('[data-bc]').forEach(function (root) {
    root.classList.add('is-js');
    var sectionId = root.getAttribute('data-section-id');
    var counts = null;

    function paintColours(scope) {
      if (!counts) return;
      scope.querySelectorAll('.shoes-bc-card[data-model-tag]').forEach(function (card) {
        var tag = card.getAttribute('data-model-tag');
        var el = card.querySelector('[data-colours]');
        var others = (counts[tag] || 0) - 1;
        if (el && others > 0) {
          el.textContent = '+' + others + ' colour' + (others === 1 ? '' : 's');
          el.hidden = false;
        }
      });
    }

    // ---- pairs per model
    var modelsUrl = root.getAttribute('data-models-url');
    function modelPage(n) {
      return get(withSection(modelsUrl + '?page=' + n, 'shoes-egy-brand-models'))
        .then(function (html) { return JSON.parse(parse(html, '[data-brand-models]').textContent); });
    }
    modelPage(1).then(function (first) {
      var rest = [];
      for (var n = 2; n <= first.pages; n++) rest.push(modelPage(n));
      return Promise.all(rest).then(function (more) {
        return more.reduce(function (all, d) { return all.concat(d.tags); }, first.tags);
      });
    }).then(function (tags) {
      counts = {};
      tags.forEach(function (t) { counts[t] = (counts[t] || 0) + 1; });
      var list = root.querySelector('[data-bc-chips]');
      if (list) {
        var items = Array.prototype.map.call(list.querySelectorAll('li:not([data-fixed])'), function (li) {
          var chip = li.querySelector('[data-tags]');
          var n = counts[chip.getAttribute('data-tags')] || 0;
          chip.querySelector('[data-count]').textContent = '(' + n + ')';
          return { li: li, n: n, active: chip.classList.contains('is-active') };
        });
        var shown = [];
        items.sort(function (a, b) { return b.n - a.n; }).forEach(function (it) {
          if (it.n === 0 && !it.active) it.li.remove(); else { list.appendChild(it.li); shown.push(it); }
        });
        collapse(list, shown);
      }
      paintColours(root);
    }).catch(function () {
      var list = root.querySelector('[data-bc-chips]');
      if (list) list.classList.add('is-ranked');
    });

    // Only the biggest models show: DESK on wide screens, MOBILE on narrow
    // ones (the CSS picks which via data-extra-desk / data-extra-mobile).
    // The open model always stays. A last chip shows the rest.
    function collapse(list, shown) {
      var DESK = 11, MOBILE = 7;
      var hidden = { desk: 0, mobile: 0 };
      shown.forEach(function (it, i) {
        if (it.active) return;
        if (i >= DESK) { it.li.setAttribute('data-extra-desk', ''); hidden.desk++; }
        if (i >= MOBILE) { it.li.setAttribute('data-extra-mobile', ''); hidden.mobile++; }
      });
      list.classList.add('is-ranked');
      if (!hidden.mobile) return;
      var li = document.createElement('li');
      li.setAttribute('data-fixed', '');
      li.className = 'shoes-bc__more-li' + (hidden.desk ? '' : ' is-mobile-only');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'shoes-bc__chip shoes-bc__chip--more';
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = '<span class="shoes-bc__more-desk">+' + hidden.desk + '</span><span class="shoes-bc__more-mobile">+' + hidden.mobile + '</span> more models' +
        '<span class="shoes-bc__more-ar" lang="ar" dir="rtl">كمان <span class="shoes-bc__more-desk">' + hidden.desk + '</span><span class="shoes-bc__more-mobile">' + hidden.mobile + '</span> موديل</span>';
      btn.addEventListener('click', function () {
        list.classList.add('is-open');
        li.remove();
      });
      li.appendChild(btn);
      list.appendChild(li);
    }

    // ---- sizes sold out across the brand
    var sizesUrl = root.getAttribute('data-sizes-url');
    // one retry: a busy storefront can answer 429, and a failed fetch would
    // leave sold-out sizes looking buyable
    var sizesHtml = function () { return get(withSection(sizesUrl, 'shoes-egy-brand-sizes')); };
    sizesHtml().catch(function () {
      return new Promise(function (resolve) { setTimeout(resolve, 1500); }).then(sizesHtml);
    }).then(function (html) {
      var data = JSON.parse(parse(html, '[data-brand-sizes]').textContent);
      root.querySelectorAll('[data-bc-sizes] [data-size]').forEach(function (a) {
        var v = a.getAttribute('data-size');
        // a size missing from the available-only counts has none left either
        if (!(data[v] > 0) && !a.classList.contains('is-active')) {
          a.classList.add('is-sold-out');
          a.setAttribute('aria-disabled', 'true');
          a.setAttribute('title', 'Sold out');
          a.addEventListener('click', function (e) { e.preventDefault(); });
        }
      });
    }).catch(function () {});

    // ---- filter panel (a <dialog>; Esc and focus come with it)
    var panel = root.querySelector('[data-bc-filters]');
    var panelOpen = root.querySelector('[data-bc-filter-open]');
    if (panel && panelOpen && typeof panel.showModal === 'function') {
      panelOpen.addEventListener('click', function () {
        panel.showModal();
        document.documentElement.classList.add('shoes-bc-panel-open');
      });
      panel.addEventListener('close', function () {
        document.documentElement.classList.remove('shoes-bc-panel-open');
        panelOpen.focus();
      });
      panel.querySelector('[data-bc-filter-close]').addEventListener('click', function () { panel.close(); });
      panel.addEventListener('click', function (e) {
        if (e.target !== panel) return;
        var r = panel.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) panel.close();
      });
      // empty price boxes would send filter.v.price.gte= and Shopify reads that as 0
      panel.querySelector('form').addEventListener('submit', function () {
        panel.querySelectorAll('input[type=number]').forEach(function (input) {
          if (input.value === '') input.disabled = true;
        });
      });
    }

    // ---- sort
    var sort = root.querySelector('[data-bc-sort]');
    if (sort) sort.addEventListener('change', function () { sort.submit(); });

    // ---- load more
    var pagesShown = 1;
    function loadNext(load) {
      load.classList.add('is-loading');
      return get(withSection(load.getAttribute('href'), sectionId)).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = root.querySelector('[data-bc-grid]');
        var fresh = doc.querySelectorAll('[data-bc-grid] > li');
        var added = document.createDocumentFragment();
        fresh.forEach(function (li) { added.appendChild(document.importNode(li, true)); });
        grid.appendChild(added);
        paintColours(grid);
        pagesShown += 1;
        var shown = grid.children.length;
        var total = parseInt(load.getAttribute('data-total'), 10) || shown;
        root.querySelectorAll('[data-bc-shown], [data-bc-shown-ar]').forEach(function (el) { el.textContent = shown; });
        var bar = root.querySelector('[data-bc-bar]');
        if (bar) bar.style.width = Math.min(100, Math.round(shown * 100 / total)) + '%';
        var next = doc.querySelector('[data-bc-load]');
        if (next) {
          load.setAttribute('href', next.getAttribute('href'));
          load.classList.remove('is-loading');
        } else {
          load.remove();
        }
      });
    }
    root.addEventListener('click', function (e) {
      var load = e.target.closest('[data-bc-load]');
      if (!load || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      loadNext(load).catch(function () { window.location.href = load.getAttribute('href'); });
    });

    // ---- ad landing pages (ad-…): sticky size bar, and back to the same spot
    // A shopper who opens a pair and comes back (back button, or the "back"
    // link the product page shows) lands on the same card, with every page
    // they had loaded with Load more loaded again.
    if (root.classList.contains('shoes-bc--ad')) {
      var header = document.querySelector('.shoes-chrome-header');
      var setTop = function () { root.style.setProperty('--bc-top', (header ? header.getBoundingClientRect().height : 0) + 'px'); };
      setTop();
      window.addEventListener('resize', setTop);
      // while stuck the bar keeps only the size row; a probe left in its place
      // says when, so the bar shrinking cannot flip it back
      var stickyBar = root.querySelector('.shoes-bc__bar');
      if (stickyBar) {
        var probe = document.createElement('div');
        stickyBar.parentNode.insertBefore(probe, stickyBar);
        var ticking = false;
        var checkStuck = function () {
          ticking = false;
          var top = header ? header.getBoundingClientRect().height : 0;
          stickyBar.classList.toggle('is-stuck', probe.getBoundingClientRect().top < top);
        };
        window.addEventListener('scroll', function () {
          if (!ticking) { ticking = true; requestAnimationFrame(checkStuck); }
        }, { passive: true });
        checkStuck();
      }

      var here = location.pathname + location.search;
      var key = 'shoes:bc:' + here;
      root.addEventListener('click', function (e) {
        if (!e.target.closest('a[href*="/products/"]')) return;
        try {
          sessionStorage.setItem(key, JSON.stringify({ pages: pagesShown, y: window.scrollY }));
          sessionStorage.setItem('shoes:adBack', here);
        } catch (err) {}
      }, true);

      var saved = null;
      var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
      try {
        var returning = nav.type === 'back_forward' || sessionStorage.getItem('shoes:adReturn') === '1';
        sessionStorage.removeItem('shoes:adReturn');
        if (returning) saved = JSON.parse(sessionStorage.getItem(key) || 'null');
      } catch (err) {}
      if (saved) {
        if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
        var restore = function () {
          var more = root.querySelector('[data-bc-load]');
          if (pagesShown < saved.pages && more) {
            loadNext(more).then(restore, function () { window.scrollTo(0, saved.y); });
          } else {
            window.scrollTo(0, saved.y);
          }
        };
        restore();
      }
    }
  });
})();
